<template>
  <div class="article-author">
    <TransitionGroup name="fade">
      <div v-for="author in authors" :key="author.id" class="article-author-wrapper">
        <RouterLink :to="{ name:'authorById', params: { locale: $i18n.localePath(), id: author.id } }" :title="author.name" class="author-avatar">
          <div v-cover-lazy-loader :data-src="author.avatar" :data-default-src="'/img/img-default/img-user-default-l.png'" class="avatar">
            <!--  -->
          </div>
        </RouterLink>
        <div class="author-info">
          <RouterLink :to="{ name:'authorById', params: { locale: $i18n.localePath(), id: author.id } }" :title="author.name" class="name">
            {{ author.name }}
          </RouterLink>
          <div class="description">
            {{ author.description }}
          </div>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import CoverLazyLoader from '@/directives/CoverLazyLoader'
export default {
  name: 'ArticleAuthorList',
  components: {},
  directives: {
    CoverLazyLoader
  },
  props: {
    authors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {}
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.article-author {
  &-wrapper {
    min-height: 48px;
    padding: 48px 0;
  }

  .author-avatar {
    display: inline-block;
    vertical-align: middle;
    width: 100px;
    height: 100px;
    cursor: pointer;
    .avatar {
      height: 100px;
      width: 100px;
      border-radius: 50%;
      background-color: $grey-ec;
      background-image: url('/img/img-default/img-user-default-l.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
  }
  .author-info {
    display: inline-block;
    vertical-align: top;
    width: calc(((100% - 100px) - 59px)); // 59 = (24 * 2 ) + inline-block offset
    // max-height: 175px;
    margin-left: 24px;
    margin-right: 24px;
    .name {
      display: block;
      height: 40px;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.63;
      color: $grey-50;
      margin-bottom: 16px;
      text-align: left;
      text-decoration: none;
      cursor: pointer;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

    }
    .description {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.6;
      color: $grey-7d;
      text-align: justify;

      max-height: 78px;
      /*! autoprefixer: ignore next  */
      @include ellipsis-with-lines(3);
    }
  }
}

@media only screen and (min-width: 1440px) {
  // As same as default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  // As same as default
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  // As same as default
}

@media only screen and (max-width: 767.98px) {
  .article-author {
    &-wrapper {
      padding: 24px 0;
    }
    .author-avatar {
      width: 60px;
      height: 60px;
      .avatar {
        height: 60px;
        width: 60px;
      }
    }
    .author-info {
      margin-left: 16px;
      margin-right: 16px;
      width: calc(((100% - 60px) - 38px)); // 38 = (16 * 2 ) + inline-block offset
      .name {
        height: 32px;
        font-size: 20px;
        line-height: 1.6;
        margin-bottom: 8px;
      }
    }
  }
}
</style>
